module.exports = __webpack_public_path__ + "static/sample-projects-2-f753b6f490352c545aa85bb895c861ae.png";